import {
  Button,
  makeStyles,
  Snackbar,
  TableCell,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { MdPersonAddAlt1 } from 'react-icons/md';
import { useNavigate } from 'react-router';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
});

export function useGrades() {
  const [grades, setGrades] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/grades')
      .then((response) => response.json())
      .then((data) => {
        setGrades(data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { grades, setGrades };
}

export default function CreateGrade() {
  const classes = useStyles();
  const { grades, setGrades } = useGrades();
  const [name, setName] = React.useState('');
  const [number, setNumber] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedGrade, setSelectedGrade] = React.useState(null);
  const navigate = useNavigate();
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (name && number) {
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/grades',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name,
              number,
            }),
          }
        );
        let data = await response.json();
        if (data.success === true) {
          navigate('/admin/grades');
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setName('');
        setNumber('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  useEffect(() => {
    if (selectedGrade) {
      setName(selectedGrade?.name);
      setNumber(selectedGrade?.number);
    }
  }, [selectedGrade]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      {/* <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell>Numero</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {grades.map((row) => (
              <StyledTableRow onClick={() => setSelectedGrade(row)} key={row._id}>
                <StyledTableCell>{row.name}</StyledTableCell>
                <StyledTableCell>{row.number}</StyledTableCell>
                <StyledTableCell>{row.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, desde esta sección podrás crear un nuevo grado
          en la plataforma, siempre y cuando se cuente con la plena autorización
          de la gerencia de Ediciones Milenio, escribe a continuación en letra y
          número el nuevo grado, recuerda que debes realizar los proceso de
          asociación dentro de la plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre del grado"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Numero del grado"
          variant="outlined"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
        />
        <Button
          onClick={() => {
            setSelectedGrade(null);
            setName('');
            setNumber('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          {/* <Button
            variant='contained'
            color='secondary'
          >
            <FaTrash size={15} />
            Eliminar
          </Button> */}
          {/* <Button variant='contained'>
            <AiFillEdit size={15} />
            Actualizar
          </Button> */}
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado el administrador exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear un nuevo usuario, por favor llene
          los campos requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
